import api from '@synergycms_core/utils/api';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { fromJS, List, Map, merge } from 'immutable';
import moment from 'moment';
import { reduce } from 'ramda';
import { enableCachePrices } from "@synergycms_core/store/app/utils";


export default {
  SET_REQUESTED: (entity, stringSearchParams) => {
    const availObj = Map({
      response: Map({ requested: true }),
    });

    return Map([[entity, Map([[stringSearchParams, availObj]])]]);
  },
  GET_ASYNC: (start = moment(), end = moment().add(1, "month").endOf("month"), customParams = false) => {
    return (dispatch, getState) => {
      

        const store = getState();
        //state
        let group = store.get("group");

        //const hotelId = store.getIn(["customer", "current_hotel"]);
        let params;
        let stringParams;
        if(customParams){
          params = customParams.params;
          stringParams = customParams.stringParams;
        } else {
          params = store.getIn(['customer', 'params', 'avail_cache_params'],Map());
          stringParams = store.getIn(['customer', 'params', 'avail_cache_query_params']);
        }

        const key = params.get("hotelId") ? "hotel" : "group";
        const value = params.get("hotelId") || group;
        const priceActive = enableCachePrices(store);
        
        if (priceActive && (params.get("hotelId") || (group && (params.get("country_id") || params.get("city_id"))))) {

          const currentAvail = store.getIn(['availCache', value, stringParams], Map());


          if (params.get('stay_length') >= 30) {
            const availObj = Map({
              raw_response: Map({ success: false }),
              response: Map({ success: false })
            });

            return Map([[key, Map([[stringParams, availObj]])]]);
          }

          const days = [];

          let current = moment(start);

          while (current <= end) {
            let date = current.format("YYYY-MM-DD");
            if (!currentAvail.get(date)) {
              days.push(date);
            }
            current.add(1, "day");
          }


          //si no te tots els dies demanem de nou les dades
          //TODO es podria millorar per demanar varis ranges
          if (params && days.length) {
            let newParams = params.set('date', moment(days[0]).format('YYYY-MM-DD')).set('checkin_days', days.length);

            const queryParams = ParamsParser.paramsToQuery(newParams);

            return api
              .get('availability/cache', {
                q: queryParams + ',' + key + ':' + value
              })
              .then(response => {

                const newAvail = reduce((acc, val) => {
                  acc[val.checkin] = val;
                  return acc
                }, {}, response);

                let mapAvail = merge(currentAvail, fromJS(newAvail));


                let monthsBestPrice = Map();
                mapAvail = mapAvail.reduce((acc, day) => {
                  day = day.set("bestPrice", false);
                  const month = moment(day.get("checkin")).month() + 1;
                  let monthdata = monthsBestPrice.get(month, day);
                  monthsBestPrice = monthsBestPrice.set(month, monthdata);

                  if (monthdata.get("price_tax") > day.get("price_tax")) {
                    monthsBestPrice = monthsBestPrice.set(month, day);
                  }

                  return acc.set(day.get("checkin"), day);
                }, Map());

                monthsBestPrice.forEach((bestDay) => {
                  let month = moment(bestDay.get("checkin")).month();
                  let bestPrice = bestDay.get("price_tax");

                  mapAvail.forEach( (monthDay) => {
                    let price = monthDay.get("price_tax");
                    let checkin = moment(monthDay.get("checkin")).month();
                    if(month === checkin && bestPrice === price){
                      mapAvail = mapAvail.setIn([monthDay.get("checkin"), "bestPrice"], true);
                    }
                  });
                });


                return Map([[value, Map([
                  [stringParams, mapAvail]
                ])]]);
              })
              .catch(error => {
                console.log(error);
                return Promise.resolve(List());
              });
          }
        }

    };
  }
};